import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { HotelImageList } from "@/features/hotels/components/hotel/HotelImageList";
import { useHotelDataContext } from "@/features/hotels/contexts/HotelDataContext";

export const Route = createFileRoute(
  "/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images",
)({
  component: RouteComponent,
  staticData: {
    drawer: false,
  },
});

function RouteComponent() {
  const intl = useIntl();
  const navigate = Route.useNavigate();

  const { data: hotel } = useHotelDataContext();

  if (!hotel) {
    // If the app fails to load the hotel data or to pass search data, redirect to the hotel list page
    // This is a fallback in case the user tries to access this page directly
    // It's unlikely that this will happen, but it's a good fallback to have
    // Avoids the need to handle these cases in the other components
    return <Navigate to=".." from={Route.fullPath} />;
  }

  return (
    <div className="px-main">
      <h2 className="mb-4 text-lg font-medium text-text-title">
        {intl.formatMessage({
          defaultMessage: "Photo gallery",
          description: "Label for the photo gallery section",
        })}
      </h2>
      <HotelImageList
        images={hotel.imagesUrls.map((url) => ({ url, name: hotel.name }))}
        onImageClick={(index) =>
          navigate({ to: "./fullscreen", search: { index } })
        }
      />
    </div>
  );
}
